import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12.5" cy="12" r="12" fill="#101010" />
      <path
        d="M13.5109 7.93908C13.5109 7.3868 13.0632 6.93908 12.5109 6.93908L12.4906 6.93908C11.9383 6.93908 11.4906 7.3868 11.4906 7.93908L11.4906 9.98985C11.4906 10.5421 11.0429 10.9898 10.4906 10.9898L8.43984 10.9898C7.88756 10.9898 7.43984 11.4376 7.43984 11.9898V12.0102C7.43984 12.5624 7.88756 13.0102 8.43984 13.0102H10.4906C11.0429 13.0102 11.4906 13.4579 11.4906 14.0102L11.4906 16.0609C11.4906 16.6132 11.9383 17.0609 12.4906 17.0609L12.5109 17.0609C13.0632 17.0609 13.5109 16.6132 13.5109 16.0609L13.5109 14.0102C13.5109 13.4579 13.9586 13.0102 14.5109 13.0102L16.5617 13.0102C17.114 13.0102 17.5617 12.5624 17.5617 12.0102V11.9898C17.5617 11.4376 17.114 10.9898 16.5617 10.9898L14.5109 10.9898C13.9586 10.9898 13.5109 10.5421 13.5109 9.98985L13.5109 7.93908Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
